"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTypeScript = void 0;
var escapeString = function (str) { return "'" + str.replace(/'/g, "\\'") + "'"; };
/**
 * Converts a type-guard schema to typescript
 * @param schema JSON schema from a type-guard to be converted
 */
function toTypeScript(schema) {
    switch (schema.type) {
        case 'any':
            return 'any';
        case 'bigint':
            return 'bigint';
        case 'boolean':
            return 'boolean';
        case 'literal':
            switch (typeof schema.constant) {
                case 'bigint':
                    return schema.constant + "n";
                case 'boolean':
                    return schema.constant.toString();
                case 'number':
                    return schema.constant.toString();
                case 'string':
                    return escapeString(schema.constant);
                default:
                    throw new Error("Unsupported schema: " + schema);
            }
        case 'never':
            return 'never';
        case 'null':
            return 'null';
        case 'number':
            return 'number';
        case 'object': {
            if (typeof schema.className === 'string') {
                switch (schema.className) {
                    case 'Array':
                        return "ReadonlyArray<" + toTypeScript(schema.items) + ">";
                    case 'Date':
                        return 'Date';
                    case 'Map':
                        return "Map<" + toTypeScript(schema.key) + ", " + toTypeScript(schema.value) + ">";
                    case 'Object':
                        return "{ " + Object.entries(schema.properties)
                            .reduce(function (acc, _a) {
                            var _b = __read(_a, 2), k = _b[0], v = _b[1];
                            return __spread(acc, ["readonly " + escapeString(k) + ": " + toTypeScript(v)]);
                        }, [])
                            .join(';') + " }";
                    case 'Set':
                        return "Set<" + toTypeScript(schema.value) + ">";
                    default:
                        throw new Error("Unsupported className: " + schema.className);
                }
            }
            else if (typeof schema.class === 'function') {
                return schema.class.name;
            }
            else if (schema.trait === 'iterable') {
                return "Iterable<" + toTypeScript(schema.items) + ">";
            }
            else {
                throw new Error("Unsupported schema: " + schema);
            }
        }
        case 'record':
            return "Record<" + toTypeScript(schema.key) + ", " + toTypeScript(schema.value) + ">";
        case 'string':
            return 'string';
        case 'tuple':
            return "readonly [" + schema.items.map(toTypeScript).join(', ') + "]";
        case 'undefined':
            return 'undefined';
        case 'union':
            return schema.schemas.map(toTypeScript).join(' | ');
        case 'unknown':
            return 'unknown';
        default:
            throw new Error("Unsupported schema: " + schema);
    }
}
exports.toTypeScript = toTypeScript;
